
import { getMapContentStoreId } from "../utils";
import { IWasmStoreMarker, TBulkOperations } from "./interfaces";
import { applyStoreItem } from "./utils";

export default class WasmStoreMarker {
	#data: IWasmStoreMarker;

	#bulkMode: boolean;

	#bulkOperations: Array<TBulkOperations>;

	constructor(opts: Partial<IWasmStoreMarker>, bulkMode = false) {
		this.#data = {
			id: getMapContentStoreId(),
			lon: 0,
			lat: 0,
			img: "",
			visual: "standard",
			draggable: false,
			lastChange: 0,
			bringToTheFront: false,
			type: "small",
			visible: true,
			customData: null,
			zIndex: null,
			angle: 0,
			interactionType: "none",
			hover: null,
			...opts,
		};
		this.#bulkMode = bulkMode;
		this.#bulkOperations = [];
		// posleme dal
		this.#addBulkItem({ type: "add-marker", data: this.#data });
	}

	update(updData: Partial<IWasmStoreMarker>) {
		const changes = {
			...updData,
			lastChange: this.#data.lastChange + 1,
		};

		this.#data = {
			...this.#data,
			...changes,
		};

		// posleme dal
		this.#addBulkItem({ type: "update-marker", id: this.#data.id, data: changes });
	}

	get id() {
		return this.#data.id;
	}

	get data() {
		return this.#data;
	}

	set bulkMode(bulkMode: boolean) {
		this.#bulkMode = bulkMode;
	}

	get bulkOperations() {
		return this.#bulkOperations;
	}

	clearBulkOperations() {
		this.#bulkOperations.length = 0;
	}

	destroy() {
		// posleme dal
		this.#addBulkItem({ type: "remove-marker", id: this.#data.id });
	}

	#addBulkItem(oper: TBulkOperations) {
		if (this.#bulkMode) {
			this.#bulkOperations.push(oper);
		} else {
			applyStoreItem(oper);
		}
	}
}
